import { Redirect, Route } from 'react-router-dom';

export default function PublicRoute({ component: Component, ...rest }) {
  const isMaintenanceMode = false;
  return (
    <Route
      {...rest}
      render={(props) =>
        !isMaintenanceMode ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  );
}
